import React, { useState } from 'react';
import { SubmitButton } from 'components/FormFields/SubmitButton';
import { InteractiveTextLink } from 'components/InteractiveTextLink';
import { InterestsSelector } from './InterestsSelector';

/**
 * @param {object} props
 * @param {(interests: string[]) => Promise<void>} props.onSave
 * @param {boolean} props.isSubmitting
 * @param {() => void} props.onSkip
 * @param {import('./').Interests} props.available
 * @param {string[]} props.initialValues
 */
export function InterestsForm({
  onSkip, available, initialValues, isSubmitting, onSave,
}) {
  const [values, setValues] = useState(initialValues);

  return (
    <div>
      <h1>What are your interests?</h1>
      <p>We use this information to create experiences just for you.</p>

      <InterestsSelector value={values} onChange={setValues} available={available} />

      <SubmitButton title="Done" disabled={isSubmitting} onClick={() => onSave(values)} />
      <InteractiveTextLink onClick={onSkip}>
        Skip
      </InteractiveTextLink>
    </div>
  );
}
